// extracted by mini-css-extract-plugin
export var logo = "_hq-2";
export var logoWrapper = "_hq-1";
export var strip = "_hq-0";